import {CLEAR_STATE, INITIALIZE} from "./available";
import _ from 'lodash'

export default {
    [INITIALIZE](state, data) {
        state.availableSpecialists = _.get(data, 'specialists', [])

        const availableClinicalDataByValues = _.get(data, 'availableClinicalData', {})
        let availableClinicalData = []
        for (let availableClinicalDataValue in availableClinicalDataByValues) {
            availableClinicalData.push({
                text: availableClinicalDataByValues[availableClinicalDataValue],
                value: availableClinicalDataValue
            })
        }

        state.availableClinicalData = availableClinicalData

        state.initialized = true
    },
    [CLEAR_STATE](state) {
        state.initialized = false
    }
}